<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    >
      <div slot="waitDeal" slot-scope="prop">
        <el-checkbox
          label="待我处理"
          name="type"
          v-model="prop.form.waitDeal"
        />
      </div>
    </qx-search-box>
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getEnumList,
} from 'api';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        loanSubjectOptions: [], // 借支类型
        stateOptions: [], // 借支状态
        form: [
          { // 待我处理
            label: '待我处理',
            value: 'waitDeal',
            default: true,
            slot: true,
          },
          { // 申请人
            label: '申请人',
            value: 'userName',
            type: 'input',
            placeholder: '请输入申请人',
          },
          { // 借支类型
            label: '借支类型',
            value: 'loanSubject',
            type: 'select',
            default: -1,
            placeholder: '请选择借支类型',
          },
          { // 申请时间
            label: '申请时间',
            value: 'Time',
            type: 'date',
            placeholder: '请选择申请时间',
            attr: {
              type: 'daterange',
            },
          },
          { // 借支号码
            label: '借支号码',
            value: 'oaLoanId',
            type: 'input',
            placeholder: '请输入借支号码',
          },
          { // 订单号码
            label: '订单号码',
            value: 'orderId',
            type: 'input',
            placeholder: '请输入订单号码',
          },
          { // 车牌号码
            label: '车牌号码',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号码',
          },
          { // 收款人
            label: '收款人',
            value: 'accName',
            type: 'input',
          },
          { // 支付流水号
            label: '支付流水号',
            value: 'flowId',
            type: 'input',
            placeholder: '请输入支付流水号',
          },
          { // 借支状态
            label: '借支状态',
            value: 'state',
            type: 'select',
            default: -1,
            placeholder: '请选择借支状态',
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      // 申请时间
      if (searchBoxData.Time && searchBoxData.Time.length > 0) {
        searchBoxData.startTime = this.formatDate(searchBoxData.Time[0]);
        searchBoxData.endTime = this.formatDate(searchBoxData.Time[1]);
      }
      delete searchBoxData.Time;
      this.$refs.tableBox.saveSearchBoxData({
        ...searchBoxData,
        queryType: 2,
      });
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'LOAN_STATE,LOAN_SUBJECT',
    });
    this.searchBoxData.stateOptions = [
      { label: '全部', value: -1 },
      ...enumsList[0],
    ];
    this.searchBoxData.loanSubjectOptions = [
      { label: '全部', value: -1 },
      ...enumsList[1],
    ];
  },
};
</script>

<style lang="scss" scoped>
</style>
